/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Profile
 */
export interface Profile {
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  email: string;
  /**
   *
   * @type {boolean}
   * @memberof Profile
   */
  isConfirmedEmail?: boolean;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  readonly phone?: string;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  patronymic?: string;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  patronymicName?: string;
  /**
   *
   * @type {boolean}
   * @memberof Profile
   */
  readonly docsIsUploaded?: boolean;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  favouritesAction?: ProfileFavouritesActionEnum;
  /**
   *
   * @type {Date}
   * @memberof Profile
   */
  readonly createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof Profile
   */
  readonly updatedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof Profile
   */
  readonly verifiedAt?: Date;
  /**
   *
   * @type {boolean}
   * @memberof Profile
   */
  readonly isVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  birthday?: string | null;
  /**
   *
   * @type {string}
   * @memberof Profile
   */
  gender?: ProfileGenderEnum;
  /**
   *
   * @type {Array<number>}
   * @memberof Profile
   */
  favourites?: Array<number>;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  inn?: string;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  snils?: string;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  passportAddress?: string;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  passportBirthPlace?: string;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  passportSeries?: string;

  /**
   *
   * @type {number}
   * @memberof Profile
   */
  passportNumber?: string;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  passportProvider?: string;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  passportProviderCode?: string;

  /**
   *
   * @type {string}
   * @memberof Profile
   */
  passportProviderDate?: string;
}

export function ProfileFromJSON(json: any): Profile {
  return ProfileFromJSONTyped(json, false);
}

export function ProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): Profile {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json['email'],
    firstName: json['firstName'],
    phone: !exists(json, 'phone') ? undefined : json['phone'],
    lastName: json['lastName'],
    patronymic: !exists(json, 'patronymic') ? undefined : json['patronymic'],
    patronymicName: !exists(json, 'patronymicName') ? undefined : json['patronymicName'],
    docsIsUploaded: !exists(json, 'docsIsUploaded') ? undefined : json['docsIsUploaded'],
    favouritesAction: !exists(json, 'favouritesAction') ? undefined : json['favouritesAction'],
    createdAt: !exists(json, 'createdAt') ? undefined : new Date(json['createdAt']),
    updatedAt: !exists(json, 'updatedAt') ? undefined : new Date(json['updatedAt']),
    verifiedAt: !exists(json, 'verifiedAt') ? undefined : new Date(json['verifiedAt']),
    isVerified: !exists(json, 'isVerified') ? undefined : json['isVerified'],
    birthday: !exists(json, 'birthday') ? undefined : json['birthday'],
    isConfirmedEmail: json['isConfirmedEmail'],
    gender: !exists(json, 'gender') ? undefined : json['gender'],
    favourites: json['favourites'],
    inn: !exists(json, 'inn') ? undefined : `${json['inn'] ? json['inn'] : ''}`,
    snils: !exists(json, 'snils') ? undefined : `${json['snils'] ? json['snils'] : ''}`,
    passportAddress: !exists(json, 'passportAddress') ? undefined : json['passportAddress'],
    passportBirthPlace: !exists(json, 'passportBirthPlace') ? undefined : json['passportBirthPlace'],
    passportSeries: !exists(json, 'passportSeries')
      ? undefined
      : `${json['passportSeries'] ? json['passportSeries'] : ''}`,
    passportNumber: !exists(json, 'passportNumber')
      ? undefined
      : `${json['passportNumber'] ? json['passportNumber'] : ''}`,
    passportProvider: !exists(json, 'passportProvider') ? undefined : json['passportProvider'],
    passportProviderCode: !exists(json, 'passportProviderCode')
      ? undefined
      : `${json['passportProviderCode'] ? json['passportProviderCode'] : ''}`,
    passportProviderDate: !exists(json, 'passportProviderDate') ? undefined : json['passportProviderDate'],
  };
}

export function ProfileToJSON(value?: Profile | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
    firstName: value.firstName,
    lastName: value.lastName,
    patronymic: value.patronymic,
    patronymicName: value.patronymicName,
    favouritesAction: value.favouritesAction,
    birthday: value.birthday,
    gender: value.gender,
    favourites: value.favourites,
    inn: +value.inn,
    snils: +value.snils,
    passportAddress: value.passportAddress,
    passportBirthPlace: value.passportBirthPlace,
    passportSeries: +value.passportSeries,
    passportNumber: +value.passportNumber,
    passportProvider: value.passportProvider,
    passportProviderCode: +value.passportProviderCode,
    passportProviderDate: value.passportProviderDate,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ProfileFavouritesActionEnum {
  Add = 'add',
  Remove = 'remove',
  Clear = 'clear',
}
/**
 * @export
 * @enum {string}
 */
export enum ProfileGenderEnum {
  Unknown = 'unknown',
  Male = 'male',
  Female = 'female',
}
